import { render, staticRenderFns } from "./legendStyle.vue?vue&type=template&id=49a90c76&scoped=true&"
import script from "./legendStyle.vue?vue&type=script&lang=js&"
export * from "./legendStyle.vue?vue&type=script&lang=js&"
import style0 from "./legendStyle.vue?vue&type=style&index=0&id=49a90c76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a90c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a90c76')) {
      api.createRecord('49a90c76', component.options)
    } else {
      api.reload('49a90c76', component.options)
    }
    module.hot.accept("./legendStyle.vue?vue&type=template&id=49a90c76&scoped=true&", function () {
      api.rerender('49a90c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/legendStyle.vue"
export default component.exports